export default "__VITE_ASSET__Bgtuh5e0__"